import { DISCUSSION, QUESTION } from '@wix/communities-forum-client-commons';

export const mapCommentingToPostType = (commentingType) => {
  return {
    reaction: [DISCUSSION],
    vote: [QUESTION],
  }[commentingType];
};
